<template>
  <div id="templatelayout">
    <!-- Popup modal display template history -->
    <popup
      v-if="num_temp_display > -1"
      :opened="num_temp_display > -1"
      @close="
        num_temp_display = -1;
        itemDisplayed = -1;
      "
    >
      <div
        v-if="
          $can(constants.PERMISSION_MODELE_DE_PAGE_REACTIVER) &&
            !evaluationInProgress
        "
      >
        <action-button
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-pink-300"
          bg-color-square="bg-pink-100"
          icon-color="text-pink-600"
          libelle="Réactiver le modèle"
          icon="power"
          @clickAction="reactivate()"
        />
      </div>
      <div class="m-5 lg:m-15 2xl:m-20">
        <!-- BEGIN Page template REF_MULTI2 (competences socio pro) -->
        <div v-if="['multi2', 'ref_multi2'].includes(infosPage.type_ref)">
          <h3 class="mb-10">
            {{ templateVersions[num_temp_display][0].name }}
          </h3>

          <div
            class="text-lg text-gray-600 grid grid-cols-10 place-content-center gap-4 h-16 lg:h-24 2xl:h-32"
          >
            <div class="ml-10 col-span-3">
              Intitulé
            </div>
            <div class="col-span-2">
              Auto-évaluation
            </div>
            <div class="col-span-2">
              Dernière éval.ref
            </div>
            <div class="col-span-2">
              Nouvelle éval.ref
            </div>
            <div class="col-span-1 text-center">
              Comm.
            </div>
          </div>

          <div
            class="odd:bg-indigo-100 odd:bg-opacity-50 relative grid grid-cols-10 place-content-center gap-4 h-16 lg:h-24 2xl:h-32"
            v-for="(intitule, index) in templateVersions[num_temp_display][2]
              .criterions"
            :key="index"
          >
            <div class="col-span-3 text-sm ml-10">
              {{ intitule.description }}
            </div>

            <input-select
              class="lg:col-span-2"
              libelle=""
              :name="index + 'auto_eval'"
              :value="
                templateVersions[num_temp_display][1].criterions[
                  Math.floor(
                    Math.random() *
                      Math.floor(
                        templateVersions[num_temp_display][1].criterions.length
                      )
                  )
                ].value
              "
              :datas="templateVersions[num_temp_display][1].criterions"
            />

            <input-text
              class="lg:col-span-2"
              libelle=""
              :name="index + 'derniere_eval'"
              disabled="true"
              :value="
                templateVersions[num_temp_display][1].criterions[
                  Math.floor(
                    Math.random() *
                      Math.floor(
                        templateVersions[num_temp_display][1].criterions.length
                      )
                  )
                ].value
              "
            />

            <input-select
              class="lg:col-span-2"
              libelle=""
              :name="index + 'nouvelle_eval'"
              :necessary="true"
              :value="
                templateVersions[num_temp_display][1].criterions[
                  Math.floor(
                    Math.random() *
                      Math.floor(
                        templateVersions[num_temp_display][1].criterions.length
                      )
                  )
                ].value
              "
              :datas="templateVersions[num_temp_display][1].criterions"
            />

            <icon-comment class="col-span-1 place-self-center" />
          </div>
        </div>
        <!-- END Page template REF_MULTI2 (competences socio pro) -->

        <!-- BEGIN Page template REF_MULTI3 (competences cle et informatique) -->
        <div v-else-if="['multi3', 'ref_multi3'].includes(infosPage.type_ref)">
          <h3 class="mb-10 w-full">
            {{ templateVersions[num_temp_display][0].name }}
          </h3>

          <div
            v-for="index in templateVersions[num_temp_display].length - 1"
            :key="index"
            class="grid grid-cols-12 mb-15"
          >
            <div
              class="col-span-full uppercase text-base text-indigo-600 text-left"
            >
              {{ templateVersions[num_temp_display][index][0].libelle }}
            </div>

            <div class="col-span-full grid grid-cols-12 gap-4">
              <div
                v-for="(field, jndex) in templateVersions[num_temp_display][
                  index
                ]"
                :key="jndex"
                class="col-span-full"
                :class="
                  jndex == 0
                    ? 'display-none'
                    : field.length > 2
                      ? 'lg:col-span-4'
                      : 'lg:col-span-6'
                "
              >
                <!-- use $set function to be reactive with form watch property -->
                <input-text
                  v-if="jndex !== 0 && field.type == 'text'"
                  :libelle="field.libelle"
                />
                <input-select
                  v-if="jndex !== 0 && field.type == 'multi'"
                  :name="
                    field.libelle
                      .toLowerCase()
                      .replace(' ', '_')
                      .replace('\'', '') +
                      index +
                      jndex
                  "
                  :libelle="field.libelle"
                  :datas="field.criterions"
                />
                <input-text-area
                  v-if="field.type == 'text-area'"
                  size="5"
                  :name="
                    field.libelle
                      .toLowerCase()
                      .replace(' ', '_')
                      .replace('\'', '')
                  "
                  :libelle="field.libelle"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- END Page template REF_MULTI3 (competences clés et informatique) -->

        <!-- BEGIN Page template REF_PRO (compétences professionnelles) -->
        <div v-else-if="['pro', 'ref_pro'].includes(infosPage.type_ref)">
          <h3 class="mb-10">
            {{ templateVersions[num_temp_display][0].name }}
          </h3>

          <div
            v-if="activities && activities.length > 0"
            class="text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center h-16 2xl:h-24"
          >
            <div class="col-start-2 col-span-3">
              Activité
            </div>
            <div
              class="col-span-4"
              v-if="
                (
                  (templateVersions[num_temp_display].filter(
                    (temp) => temp.libelle === 'Niveau de maîtrise acquis'
                  ) || [])[0] || {}
                ).included
              "
            >
              Niveau de maîtrise
            </div>
            <div
              class="col-span-4"
              v-if="
                (
                  (templateVersions[num_temp_display].filter(
                    (temp) => temp.libelle === 'Temps consacré'
                  ) || [])[0] || {}
                ).included
              "
            >
              Temps consacré
            </div>
          </div>

          <!-- BEGIN list of parcours -->
          <div
            v-for="(activity, num) in activities"
            :key="num"
            class="odd:bg-indigo-100 odd:bg-opacity-50"
          >
            <!-- BEGIN Informations on accordion -->
            <div
              class="h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
              :class="{
                'bg-indigo-200 border-l-2 border-indigo-600':
                  itemDisplayed == num,
              }"
              @click="displayItem(num)"
              :id="'item' + num"
            >
              <div class="col-span-1 text-pink-600 justify-self-center">
                <icon
                  class="transform transition-transform ease-in-out duration-300 mt-1.5"
                  :class="{ 'rotate-90': itemDisplayed == num }"
                  name="chevron-right"
                />
              </div>
              <div class="col-span-3 text-base font-normal">
                <!-- Activité -->
                <span>{{ activity.name }}</span>
              </div>
              <div
                v-if="
                  (
                    (templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise acquis'
                    ) || [])[0] || {}
                  ).included
                "
                class="col-span-4 text-base font-normal"
              >
                <!-- Niveau de maîtrise -->
                <span
                  v-if="
                    activity.lvl !== '' ||
                      activity.lvl !== undefined ||
                      activity.lvl !== null
                  "
                >
                  {{ activity.lvl }}
                </span>
              </div>
              <div
                v-if="
                  (
                    (templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Temps consacré'
                    ) || [])[0] || {}
                  ).included
                "
                class="col-span-4 text-base italic font-normal"
              >
                <!-- Temps consacré -->
                <span
                  v-if="
                    activity.time !== '' ||
                      activity.time !== undefined ||
                      activity.time !== null
                  "
                >
                  {{ activity.time }}
                </span>
              </div>
            </div>

            <div
              v-if="itemDisplayed == num"
              class="bg-white p-5 md:p-15 md:pb-0"
            >
              <div class="grid grid-cols-12 gap-x-4 gap-y-10 mb-15">
                <input-select
                  v-if="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Temps consacré'
                    )[0].included
                  "
                  :name="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Temps consacré'
                    )[0].libelle + num
                  "
                  :libelle="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Temps consacré'
                    )[0].libelle
                  "
                  :value="activity.time"
                  :datas="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Temps consacré'
                    )[0].criterions
                  "
                  class="lg:col-span-3"
                />
                <input-select
                  v-if="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise requis'
                    )[0].included
                  "
                  :name="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise requis'
                    )[0].libelle + num
                  "
                  :libelle="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise requis'
                    )[0].libelle
                  "
                  :value="activity.lvl"
                  :datas="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise requis'
                    )[0].criterions
                  "
                  class="lg:col-span-3"
                />
                <input-select
                  v-if="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise acquis'
                    )[0].included
                  "
                  :name="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise acquis'
                    )[0].libelle + num
                  "
                  :libelle="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise acquis'
                    )[0].libelle
                  "
                  :value="activity.requis"
                  :datas="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Niveau de maîtrise acquis'
                    )[0].criterions
                  "
                  class="lg:col-span-3"
                />
                <input-select
                  v-if="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Perspectives d\'évolution'
                    )[0].included
                  "
                  :name="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Perspectives d\'évolution'
                    )[0].libelle + num
                  "
                  :libelle="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Perspectives d\'évolution'
                    )[0].libelle
                  "
                  :value="activity.evo"
                  :datas="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Perspectives d\'évolution'
                    )[0].criterions
                  "
                  class="lg:col-span-3"
                />
              </div>

              <!-- BEGIN Liste des tâches de l'activité -->
              <div
                class="col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
              >
                <div class="col-span-full uppercase text-indigo-600 text-base">
                  Tâches Principales
                </div>

                <div
                  v-if="activity.tasks && activity.tasks.length > 0"
                  class="col-span-full"
                >
                  <div class="text-lg text-gray-600 grid grid-cols-10 gap-x-4">
                    <div class="col-span-3 ml-10">
                      Tâche
                    </div>
                    <div class="col-span-2 text-center">
                      Auto-évaluation
                    </div>
                    <div class="col-span-2 text-center">
                      Dernière eval. ref.
                    </div>
                    <div class="col-span-2 text-center">
                      Nouvelle eval. ref.
                    </div>
                    <div class="col-span-1 text-center">
                      Comm.
                    </div>
                  </div>

                  <div
                    v-for="(task, index) in activity.tasks"
                    :key="index"
                    class="odd:bg-indigo-100 odd:bg-opacity-50"
                  >
                    <!-- BEGIN Informations on accordion -->
                    <div
                      class="h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
                    >
                      <div
                        class="col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
                      >
                        <!-- Only display the icon for tasks -->
                        <!-- <icon v-if="name.includes('tasks')" name="camera" class="text-pink-600"/> -->
                        {{ task.name }}
                      </div>

                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-select
                        libelle=""
                        class="lg:col-span-2"
                        :name="index + num + 'tasks'"
                        :value="task.auto"
                        :datas="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions
                        "
                      />

                      <icon-comment
                        :name="'comment-' + num + '-' + task.name + '-' + index"
                        class="lg:col-span-1 cursor-pointer lg:place-self-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Liste des tâches de l'activité -->

              <!-- BEGIN Liste des Pratiques Professionelles de l'activité -->
              <div
                class="col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
              >
                <div class="col-span-full uppercase text-indigo-600 text-base">
                  Pratiques Professionnelles
                </div>

                <div
                  v-if="
                    activity.pratiques_pro && activity.pratiques_pro.length > 0
                  "
                  class="col-span-full"
                >
                  <div class="text-lg text-gray-600 grid grid-cols-10 gap-x-4">
                    <div class="col-span-3 ml-10">
                      Comportement
                    </div>
                    <div class="col-span-2 text-center">
                      Auto-évaluation
                    </div>
                    <div class="col-span-2 text-center">
                      Dernière eval. ref.
                    </div>
                    <div class="col-span-2 text-center">
                      Nouvelle eval. ref.
                    </div>
                    <div class="col-span-1 text-center">
                      Comm.
                    </div>
                  </div>

                  <div
                    v-for="(pra, index) in activity.pratiques_pro"
                    :key="index"
                    class="odd:bg-indigo-100 odd:bg-opacity-50"
                  >
                    <!-- BEGIN Informations on accordion -->
                    <div
                      class="h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
                    >
                      <div
                        class="col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
                      >
                        <!-- Only display the icon for tasks -->
                        <!-- <icon v-if="name.includes('tasks')" name="camera" class="text-pink-600"/> -->
                        {{ pra.name }}
                      </div>

                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-select
                        libelle=""
                        class="lg:col-span-2"
                        :name="index + num + 'pra'"
                        :value="pra.auto"
                        :datas="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions
                        "
                      />

                      <icon-comment
                        :name="'comment-' + num + '-' + pra.name + '-' + index"
                        class="lg:col-span-1 cursor-pointer lg:place-self-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Liste des Pratiques Professionelles de l'activité -->

              <!-- BEGIN Liste des Connaissances associées de l'activité -->
              <div
                class="col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
              >
                <div class="col-span-full uppercase text-indigo-600 text-base">
                  Connaissances associées
                </div>

                <div
                  v-if="
                    activity.activity_connaissances &&
                      activity.activity_connaissances.length > 0
                  "
                  class="col-span-full"
                >
                  <div class="text-lg text-gray-600 grid grid-cols-10 gap-x-4">
                    <div class="col-span-3 ml-10">
                      Connaissance
                    </div>
                    <div class="col-span-2 text-center">
                      Auto-évaluation
                    </div>
                    <div class="col-span-2 text-center">
                      Dernière eval. ref.
                    </div>
                    <div class="col-span-2 text-center">
                      Nouvelle eval. ref.
                    </div>
                    <div class="col-span-1 text-center">
                      Comm.
                    </div>
                  </div>

                  <div
                    v-for="(con, index) in activity.activity_connaissances"
                    :key="index"
                    class="odd:bg-indigo-100 odd:bg-opacity-50"
                  >
                    <!-- BEGIN Informations on accordion -->
                    <div
                      class="h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
                    >
                      <div
                        class="col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
                      >
                        <!-- Only display the icon for tasks -->
                        <!-- <icon v-if="name.includes('tasks')" name="camera" class="text-pink-600"/> -->
                        {{ con.name }}
                      </div>

                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-select
                        libelle=""
                        class="lg:col-span-2"
                        :name="index + num + 'con'"
                        :value="con.auto"
                        :datas="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions
                        "
                      />

                      <icon-comment
                        :name="'comment-' + num + '-' + con.name + '-' + index"
                        class="lg:col-span-1 cursor-pointer lg:place-self-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Liste des Connaissances associées de l'activité -->

              <!-- BEGIN Liste des Comportement / Attitudes de l'activité -->
              <div
                class="col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
              >
                <div class="col-span-full uppercase text-indigo-600 text-base">
                  Comportement / Attitudes
                </div>

                <div
                  v-if="
                    activity.activity_comportement &&
                      activity.activity_comportement.length > 0
                  "
                  class="col-span-full"
                >
                  <div class="text-lg text-gray-600 grid grid-cols-10 gap-x-4">
                    <div class="col-span-3 ml-10">
                      Pratique
                    </div>
                    <div class="col-span-2 text-center">
                      Auto-évaluation
                    </div>
                    <div class="col-span-2 text-center">
                      Dernière eval. ref.
                    </div>
                    <div class="col-span-2 text-center">
                      Nouvelle eval. ref.
                    </div>
                    <div class="col-span-1 text-center">
                      Comm.
                    </div>
                  </div>

                  <div
                    v-for="(com, index) in activity.activity_comportement"
                    :key="index"
                    class="odd:bg-indigo-100 odd:bg-opacity-50"
                  >
                    <!-- BEGIN Informations on accordion -->
                    <div
                      class="h-16 lg:h-24 2xl:h-32 grid grid-cols-10 gap-x-4 place-content-center cursor-default"
                    >
                      <div
                        class="col-span-full lg:col-span-3 text-base font-normal lg:place-self-center lg:justify-self-start ml-10"
                      >
                        <!-- Only display the icon for tasks -->
                        <!-- <icon v-if="name.includes('tasks')" name="camera" class="text-pink-600"/> -->
                        {{ com.name }}
                      </div>

                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-text
                        libelle=""
                        class="lg:col-span-2"
                        :value="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions[
                            Math.floor(
                              Math.random() *
                                templateVersions[num_temp_display].filter(
                                  (temp) =>
                                    temp.libelle === 'Critères d\'évaluation'
                                )[0].criterions.length
                            )
                          ].value
                        "
                        disabled="true"
                      />
                      <input-select
                        libelle=""
                        class="lg:col-span-2"
                        :name="index + num + 'com'"
                        :value="com.auto"
                        :datas="
                          templateVersions[num_temp_display].filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions
                        "
                      />

                      <icon-comment
                        :name="'comment-' + num + '-' + com.name + '-' + index"
                        class="lg:col-span-1 cursor-pointer lg:place-self-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Liste des Comportement / Attitudes de l'activité -->
            </div>
          </div>
        </div>
        <!-- END Page template REF_PRO (compétences professionnelles) -->

        <!-- BEGIN Page template REF_SCO (compétences professionnelles pour OF) -->
        <div v-else-if="['sco', 'ref_sco'].includes(infosPage.type_ref)">
          <h3 class="mt-15 mb-15 w-full">
            {{ infosPage.libelle_template }}
          </h3>

          <!-- BEGIN Remplir avec le modèle de page correspondant -->
          <div
            v-if="modules && modules.length > 0"
            class="text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center h-16 2xl:h-24"
          >
            <div class="col-start-2 col-span-7">
              Module
            </div>
            <div class="col-span-4">
              Temps consacré
            </div>
          </div>

          <!-- BEGIN list of parcours -->
          <div
            v-for="(mod, num) in modules"
            :key="num"
            class="odd:bg-indigo-100 odd:bg-opacity-50"
          >
            <!-- BEGIN Informations on accordion -->
            <div
              class="h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
              :class="{
                'bg-indigo-200 border-l-2 border-indigo-600':
                  itemDisplayed == num,
              }"
              @click="displayItem(num)"
              :id="'item' + num"
            >
              <div
                class="col-span-1 text-pink-600 justify-self-center flex flex-col justify-around"
              >
                <icon
                  class="transform transition-transform ease-in-out duration-300"
                  :class="{ 'rotate-90': itemDisplayed == num }"
                  name="chevron-right"
                />
              </div>
              <div class="col-span-7 text-base font-normal">
                <span>{{ mod.display_name }}</span>
              </div>
              <div class="col-span-4 text-base font-normal">
                <span
                  v-if="
                    mod.general.filter((gen) => gen.name.includes('Temps'))
                      .length > 0 &&
                      (mod.general.filter((gen) => gen.name.includes('Temps'))[0]
                        .value !== '' ||
                        mod.general.filter((gen) => gen.name.includes('Temps'))[0]
                          .value !== undefined ||
                        mod.general.filter((gen) => gen.name.includes('Temps'))[0]
                          .value !== null ||
                        mod.general.filter((gen) => gen.name.includes('Temps'))[0]
                          .value !== [])
                  "
                >
                  {{
                    mod.general.filter((gen) => gen.name.includes('Temps'))[0]
                      .value
                  }}
                </span>
              </div>
            </div>
            <transition
              enter-active-class="ease-out duration-300"
              enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to-class="opacity-100 translate-y-0 sm:scale-100"
              leave-active-class="ease-in duration-200"
              leave-class="opacity-100 translate-y-0 sm:scale-100"
              leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div
                v-if="itemDisplayed == num"
                class="bg-white my-5 lg:my-10 px-10"
              >
                <div class="grid grid-cols-12 gap-x-4 gap-y-10 mb-15">
                  <div
                    v-for="(gen, index) in templateVersions[
                      num_temp_display
                    ].filter(
                      (temp) =>
                        temp.libelle &&
                        !['Critères d\'évaluation', 'Critères'].includes(
                          temp.libelle
                        )
                    )"
                    :key="index"
                    class="col-span-6"
                  >
                    <input-select
                      :name="gen.libelle.replace('\'', '')"
                      :libelle="gen.libelle"
                      :value="mod.general[index].value"
                      :datas="gen.criterions"
                      @input="
                        (newValue) => {
                          $set(mod.general[index], 'value', newValue);
                        }
                      "
                    />
                  </div>
                </div>

                <module-category
                  :datas="mod.module_competences"
                  :form="mod.module_competences"
                  :list-criterions="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Critères d\'évaluation'
                    )[0].criterions
                  "
                  name="module_competences"
                  :id-pass="user.id"
                  :id-user="user.id"
                  :hidden-fields="hiddenFields"
                  :num="num"
                  :latest-eval="[]"
                  @hideField="
                    (field) => {
                      hiddenFields[field] = !hiddenFields[field];
                    }
                  "
                  :preview-mode="true"
                />

                <module-category
                  :datas="mod.module_competences_transversales"
                  :form="mod.module_competences_transversales"
                  :list-criterions="
                    templateVersions[num_temp_display].filter(
                      (temp) => temp.libelle === 'Critères d\'évaluation'
                    )[0].criterions
                  "
                  name="module_competences_transversales"
                  :id-pass="user.id"
                  :id-user="user.id"
                  :hidden-fields="hiddenFields"
                  :num="num"
                  :latest-eval="[]"
                  @hideField="
                    (field) => {
                      hiddenFields[field] = !hiddenFields[field];
                    }
                  "
                  :preview-mode="true"
                />
              </div>
            </transition>
          </div>
        </div>
        <!-- END Page template REF_SCO (compétences professionnelles pour OF) -->

        <!-- BEGIN Page template REF_MULTI1 (compétences linguistiques) -->
        <div v-else-if="['multi1', 'ref_multi1'].includes(infosPage.type_ref)">
          <!-- Référentiel multi pour les langues -->
          <h3 class="mb-10 w-full">
            {{ templateVersions[num_temp_display][0].name }}
          </h3>
          <div class="grid grid-cols-12 gap-x-4 gap-y-10">
            <div
              v-for="(field, jndex) in templateVersions[num_temp_display]"
              :key="jndex"
              class="col-span-full lg:col-span-3 flex"
              :class="{
                'lg:col-start-1': jndex == 1,
                'lg:col-span-4': jndex == 0,
              }"
            >
              <!-- BEGIN Button to delete a "langue" -->
              <div
                class="pt-8 mr-4 cursor-pointer"
                v-if="jndex == 0"
              >
                <span class="minus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
                  <icon name="close" />
                </span>
              </div>
              <!-- END Button to delete a "langue" -->

              <!-- use $set function to be reactive with form watch property -->
              <input-text
                v-if="field.type == 'text' && jndex == 0"
                :libelle="field.libelle"
              />
              <input-text
                v-else-if="field.type == 'text' && jndex > 0"
                :libelle="field.libelle"
              />
              <input-select
                v-else-if="field.type == 'multi'"
                :name="
                  field.libelle
                    .toLowerCase()
                    .replace(' ', '_')
                    .replace('\'', '') + jndex
                "
                :libelle="field.libelle"
                :datas="field.criterions"
              />
            </div>
          </div>
        </div>
        <!-- END Page template REF_MULTI1 (compétences linguistiques) -->
      </div>
    </popup>
    <!-- END Popup modal display template history -->

    <module-header
      module-name="Modèles de pages"
      illustration-name="templates"
    >
      <template #ariane-wire>
        <div class="inline-flex flex-col xxl:flex-row flex-wrap w-8/12">
          <div class="text-indigo-600 inline-flex font-light">
            <icon name="file-add" />
            <div>&nbsp;Modèles de pages&nbsp;</div>
            <span class="hidden xxl:inline-block">>&nbsp;</span>
          </div>
          <span class="text-pink-600 font-light">{{ infosPage.libelle_module }}
            <span class="hidden xxl:inline-block">>&nbsp;</span>
          </span>
          <span class="text-gray-600 font-light">{{
            infosPage.libelle_template
          }}</span>
        </div>
      </template>
    </module-header>

    <div v-if="allowed">
      <!-- Contenu -->
      <div
        class="relative flex flex-col align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 min-h-halfscreen"
      >
        <message-header
          :message-header="messageHeader"
          @cancel="cancel_nosave()"
          @quit="quit_nosave()"
        />

        <div class="sticky top-9/10 md:top-0 z-10">
          <save-button
            class="right-1/2 transform translate-x-1/2 md:right-15 md:translate-x-0 md:top-10"
            :saving="saving"
            @save="save_datas($refs.template.template)"
          />
        </div>
        <router-view ref="template" />
      </div>
      <!-- Fin Contenu -->

      <!-- BEGIN History -->
      <div class="flex flex-col mt-16">
        <div class="-my-2 py-2">
          <div
            class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table"
          >
            <h3 class="mt-10 mb-10 w-full">
              Historique du modèle de page
            </h3>

            <list-grid
              :list-items="templateVersions"
              @displayNum="displayHistory"
              v-if="templateVersions.length > 0"
            >
              <template #header>
                <div class="ml-5 md:ml-0 col-start-1 md:col-start-2 col-span-3">
                  Nom modèle
                </div>
                <div class="col-span-2hidden md:inline">
                  1ère évaluation
                </div>
                <div class="col-span-2hidden md:inline">
                  Dernière évaluation
                </div>
                <div class="col-span-5 md:hidden">
                  Evaluations
                </div>
                <div
                  v-if="['multi2', 'ref_multi2'].includes(infosPage.type_ref)"
                  class="col-span-2"
                >
                  Nb. intitulé(s)
                </div>
                <div
                  v-else
                  class="col-span-2"
                >
                  Nb. champ(s)
                </div>
                <div class="col-span-2">
                  Nb. évaluation(s)
                </div>
              </template>
              <template
                #accordionDescription="{item: template, num: num_temp}"
              >
                <template
                  v-if="['multi2', 'ref_multi2'].includes(infosPage.type_ref)"
                >
                  <div
                    class="col-span-1 hidden md:flex place-self-center text-pink-600 justify-center"
                  >
                    <icon name="eye" />
                  </div>
                  <div
                    class="ml-5 md:ml-0 col-span-3 text-base place-self-center justify-self-start"
                  >
                    {{ template[0].name }}
                  </div>
                  <div
                    class="col-span-2 hidden md:inline text-base place-self-center justify-self-start"
                  >
                    {{ new Date(template[0].first_eval).toLocaleDateString() }}
                  </div>
                  <div
                    class="col-span-2 hidden md:inline text-base place-self-center justify-self-start"
                  >
                    {{ new Date(template[0].last_eval).toLocaleDateString() }}
                  </div>
                  <div class="col-span-5 md:hidden text-base place-self-center justify-self-start">
                    {{ new Date(template[0].first_eval).toLocaleDateString() }} - {{ new Date(template[0].last_eval).toLocaleDateString() }}
                  </div>
                  <div class="col-span-2 text-base place-self-center">
                    {{ template[2].criterions.length - 1 }}
                  </div>
                  <div class="col-span-2 text-base place-self-center">
                    {{ template[0].nb_eval }}
                  </div>
                </template>
                <template v-else>
                  <div
                    class="ml-5 md:ml-0 col-span-1 place-self-center text-pink-600 hidden md:flex justify-center"
                  >
                    <icon name="eye" />
                  </div>
                  <div
                    class="col-span-3 text-base place-self-center justify-self-start"
                  >
                    {{ template[0].name }}
                  </div>
                  <div
                    class="col-span-2 hidden md:inline text-base place-self-center justify-self-start"
                  >
                    {{ new Date(template[0].first_eval).toLocaleDateString() }}
                  </div>
                  <div
                    class="col-span-2 hidden md:inline text-base place-self-center justify-self-start"
                  >
                    {{ new Date(template[0].last_eval).toLocaleDateString() }}
                  </div>
                  <div class="col-span-5 md:hidden text-base place-self-center justify-self-start">
                    {{ new Date(template[0].first_eval).toLocaleDateString() }} - {{ new Date(template[0].last_eval).toLocaleDateString() }}
                  </div>
                  <div class="col-span-2 text-base place-self-center">
                    {{ template.length - 1 }}
                  </div>
                  <div class="col-span-2 text-base place-self-center">
                    {{ template[0].nb_eval }}
                  </div>
                </template>
              </template>
            </list-grid>

            <div v-else>
              <h6 class="text-indigo-600 mb-12">
                Il n'y a pas encore de modèle de page historisé.
              </h6>
              <div class="flex justify-center">
                <illustration name="notAllowed" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END History -->
    </div>
    <page-not-allowed v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import router from '../../router';
import store from '../../store';

import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import ActionButton from '../../components/ActionButton';
import SaveButton from './../../components/SaveButton.vue';

import InputText from '../../components/Inputs/InputText';
import InputSelect from '../../components/Inputs/InputSelect';
import InputTextArea from '../../components/Inputs/InputTextArea';
import IconComment from '../../components/Inputs/IconComment';

import Popup from '../../components/Popup';
import PageNotAllowed from '../../components/PageNotAllowed';
import MessageHeader from '../../components/MessageHeader';
import ModuleCategory from '../../components/CompetencesPro/ModuleCategory';
import ModuleHeader from '../../components/ModuleHeader.vue';

import Constants from './../../constants';
import ListGrid from '../../components/AccordionTable/ListGrid.vue';

export default {
  components: {
    ListGrid,
    ActionButton,
    InputSelect,
    InputText,
    InputTextArea,
    Icon,
    Illustration,
    Popup,
    IconComment,
    PageNotAllowed,
    MessageHeader,
    ModuleCategory,
    ModuleHeader,
    SaveButton,
  },

  name: 'TemplateLayout',

  data() {
    return {
      num_temp_display: -1,
      nom_langue_preview: 'Anglais',

      activities: [
        {
          name: 'Activité 1',
          lvl: '',
          time: '',
          evo: '',
          requis: '',
          tasks: [
            { name: 'Tâche 1', auto: '', last: '', eval: '' },
            { name: 'Tâche 2', auto: '', last: '', eval: '' },
            { name: 'Tâche 3', auto: '', last: '', eval: '' },
          ],
          pratiques_pro: [
            { name: 'Pratique 1', last: '', eval: '', cv: false },
            { name: 'Pratique 2', last: '', eval: '', cv: false },
            { name: 'Pratique 3', last: '', eval: '', cv: false },
          ],
        },
        {
          name: 'Activité 2',
          lvl: '',
          time: '',
          tasks: [
            { name: 'Tâche 1', auto: '', last: '', eval: '' },
            { name: 'Tâche 2', auto: '', last: '', eval: '' },
            { name: 'Tâche 3', auto: '', last: '', eval: '' },
          ],
          pratiques_pro: [
            { name: 'Pratique 1', last: '', eval: '', cv: false },
            { name: 'Pratique 2', last: '', eval: '', cv: false },
            { name: 'Pratique 3', last: '', eval: '', cv: false },
          ],
        },
        {
          name: 'Activité 3',
          lvl: '',
          time: '',
          tasks: [
            { name: 'Tâche 1', auto: '', last: '', eval: '' },
            { name: 'Tâche 2', auto: '', last: '', eval: '' },
            { name: 'Tâche 3', auto: '', last: '', eval: '' },
          ],
          pratiques_pro: [
            { name: 'Pratique 1', last: '', eval: '', cv: false },
            { name: 'Pratique 2', last: '', eval: '', cv: false },
            { name: 'Pratique 3', last: '', eval: '', cv: false },
          ],
        },
        {
          name: 'Activité 4',
          lvl: '',
          time: '',
          tasks: [
            { name: 'Tâche 1', auto: '', last: '', eval: '' },
            { name: 'Tâche 2', auto: '', last: '', eval: '' },
            { name: 'Tâche 3', auto: '', last: '', eval: '' },
          ],
          pratiques_pro: [
            { name: 'Pratique 1', last: '', eval: '', cv: false },
            { name: 'Pratique 2', last: '', eval: '', cv: false },
            { name: 'Pratique 3', last: '', eval: '', cv: false },
          ],
        },
      ],

      modules: [
        {
          libelle: 'Module 1',
          general: [
            { name: 'Temps consacré', value: '' },
            { name: 'Perspectives d\'évolution', value: '' },
          ],
          module_competences: [
            {
              name: 'Compétence 1',
              critères: [
                {
                  name: 'Critère 1',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 2',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 3',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
              ],
            },
            {
              name: 'Compétence 2',
              critères: [
                {
                  name: 'Critère 1',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 2',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 3',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
              ],
            },
            {
              name: 'Compétence 3',
              critères: [
                {
                  name: 'Critère 1',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 2',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 3',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
              ],
            },
          ],
          module_competences_transversales: [
            {
              name: 'Compétence 1',
              critères: [
                {
                  name: 'Critère 1',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 2',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 3',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
              ],
            },
            {
              name: 'Compétence 2',
              critères: [
                {
                  name: 'Critère 1',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 2',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 3',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
              ],
            },
            {
              name: 'Compétence 3',
              critères: [
                {
                  name: 'Critère 1',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 2',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
                {
                  name: 'Critère 3',
                  auto: '',
                  indicateur: null,
                  last: '',
                  value: '',
                  comment: '',
                },
              ],
            },
          ],
        },
        {
          libelle: 'Module 2',
          general: [
            { name: 'Temps consacré', value: '' },
            { name: 'Perspectives d\'évolution', value: '' },
          ],
        },
        {
          libelle: 'Module 3',
          general: [
            { name: 'Temps consacré', value: '' },
            { name: 'Perspectives d\'évolution', value: '' },
          ],
        },
        {
          libelle: 'Module 4',
          general: [
            { name: 'Temps consacré', value: '' },
            { name: 'Perspectives d\'évolution', value: '' },
          ],
        },
      ],
      itemDisplayed: -1,
      constants: Constants,
    };
  },

  methods: {
    ...mapActions({
      save_datas: 'template/save_datas',
      reactivate_template: 'template/reactivate_template',
      change_page: 'template/change_page',
    }),

    displayItem(numItem) {
      if (this.itemDisplayed == numItem) {
        this.itemDisplayed = -1;
      } else {
        this.itemDisplayed = numItem;
        let pos = document.getElementById('item' + numItem);
        setTimeout(() => {
          pos.scrollIntoView({ block: 'start' });
        }, 300);
      }
    },

    displayHistory(num_temp) {
      this.num_temp_display = num_temp;
    },

    async reactivate() {
      await this.reactivate_template(this.num_temp_display);
      await this.$refs.template.initPage();

      this.num_temp_display = -1;
    },

    cancel_nosave() {
      store.commit('template/SET_MESSAGEHEADER', {
        type: '',
        msg: '',
        url: '',
      });
    },

    quit_nosave() {
      this.infosPage.isTemplateChanged = false;
      router.push(this.messageHeader.url.url);
      store.commit('template/SET_MESSAGEHEADER', {
        type: '',
        msg: '',
        url: '',
      });
    },
  },

  computed: {
    ...mapGetters({
      infosPage: 'template/infosPage',
      messageHeader: 'template/messageHeader',
      loading: 'template/loading',
      templateVersions: 'template/templateVersions',
      allowed: 'app/allowed',
      user: 'auth/user',
      evaluationInProgress: 'template/evaluationInProgress',
      saving: 'template/saving',
    }),
  },
};
</script>
